var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"background":"#DDD"}},[_c('Banner',{attrs:{"value":"Logotipo"}}),_c('AppLogo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }